<template>
  <div v-cloak class="bg-f6 conten">
    <coupon-default v-if="0"></coupon-default>
    <div v-else class="padding15">
        <div v-for='(item,index) in couponList' :key=index class="bgCoupon white row unavailable  margin15-bottom" :class="{'available':item.isHave}">
            <span class='priceBox text-center ilbk'>
                <span class="ft15">¥</span>
                <span class="ft30">{{item.amount}}</span>
                <p v-if='!item.isHave' class='ft12'>不可用</p>
            </span>
            <div class='ft11 gray-3 ilbk couponText padding10-left'>
                <p class='ft16'>{{item.name}}</p> 
                <p class="gray-6">适用课程：{{item.courseTitle}}</p>
                <p class="gray-6">使用期限：{{item.startDate}}至{{item.endDate}}</p>
            </div>
            
            <span @click='selectCp(index)' class="ilbk btnRadio" v-if='item.isHave'>
                <img v-if='clickFlag == index' src="../../assets/imgs/se_cp.png" alt="">
                <img v-else src="../../assets/imgs/de_cp.png" alt="">
            </span>
        </div>
       
    </div>
  </div>
</template>

<script>
import CouponDefault from '../../components/default/couponDefault'
import { getCouponList } from "../../model/coupon/couponServer";
import { CacheModule } from "../../utils/commonUtils"

export default {
  name: 'selectCoupon',
  data(){
      return {
         couponList:[],
         clickFlag:99, 
      }
  },
  components: {
    CouponDefault
  },
  created(){
    getCouponList({cid:this.$route.query.cid}).then(res=>{
        this.couponList = res.data
    })
  },
  mounted() {
    let couponParme = CacheModule.getSessionStorage('couponParme')
    if(couponParme ){
        this.clickFlag = couponParme.index
    }
  },
  methods: {
      selectCp(index){
          this.clickFlag = index
          this.couponList[index].index = index
          CacheModule.setSessionStorage('couponParme',this.couponList[index])
          this.$router.go(-1)
      }
  }
}
</script>
<style scoped lang="less">
.bgCoupon{
    width: 100%;
    height: 101/20rem;
    box-sizing: border-box;
    // padding:0 0 0 .5rem;
    align-items: center;
}
.btnRadio{
    width: 22/20rem;
    height: 22/20rem;
    margin-left: 2.5rem;
}
.priceBox{
    width:92/20rem;
}
.couponText{
    width: 158/20rem;
}
.couponBox{
    width: 205/20rem;
}
.unavailable{
    background-image: url('../../assets/imgs/gray_cp.png');
    background-size: 100% 100%;
}
.available{
    background-image: url('../../assets/imgs/cp.png');
    background-size: 100% 100%;
}
.padding20_left{
    // padding-left:1rem;
}
.couponBtn{
    width:74/20rem;
    height:28/20rem;
    line-height:28/20rem;
    margin-left:.25rem;
    background:linear-gradient(90deg,rgba(255,105,47,1),rgba(240,129,66,1));
    box-shadow:0px 0px 5px 0px rgba(241,132,69,0.45);
    border-radius:14px;
}
</style>